import React from "react";
import { createPortal } from "react-dom";
import {
  Button, Modal, ModalBody,
  ModalFooter, ModalHeader
} from "reactstrap";

const ConfirmModal = (props) => {
  const { onConfirm, isOpen, toggle, title, primaryBtn = "Aceptar", 
    primaryBtnColor = "primary", secondaryBtn = "Cancelar", secondaryBtnColor = "danger", } = props;

  const triggerOnConfirm = (e) => {
    if (onConfirm) {
      onConfirm(e)
    }
  }

  return isOpen && createPortal(
    <>
      <Modal
        toggle={toggle}
        isOpen={isOpen}
      >
        {title && (
          <ModalHeader toggle={toggle}>
            {title}
          </ModalHeader>
        )}
        <ModalBody>
          {props.children}
        </ModalBody>
        <ModalFooter>
          <Button
            color={primaryBtnColor}
            onClick={(e) => {triggerOnConfirm(e) }}
          >
            {primaryBtn}
          </Button>
          {' '}
          <Button color={secondaryBtnColor} onClick={toggle}>
            {secondaryBtn}
          </Button>
        </ModalFooter>
      </Modal>
    </>
    , document.body);

}

export default ConfirmModal;